import React from 'react';
import { Select } from 'antd';
const Option = Select.Option;

const TablePageSize = ({ pageSize, handleChangePagination }) => {
  return (
    <div className="employees__table-pages">
      <span className="employees__pages-title">Показать на странице</span>
      <Select
        defaultValue={pageSize}
        style={{ width: 80 }}
        onChange={handleChangePagination}
        getPopupContainer={trigger => trigger.parentNode}
      >
        <Option value="3">3</Option>
        <Option value="5">5</Option>
        <Option value="10">10</Option>
      </Select>
    </div>
  );
};

export default TablePageSize;
